var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c(
      "div",
      { staticClass: "content6" },
      [
        _vm.$route.path != "/profile"
          ? _c("router-link", { attrs: { to: { name: "Home" } } }, [
              _c("div", { staticClass: "content6-logo" }, [
                _c("img", {
                  attrs: {
                    height: "43px",
                    width: "174px",
                    src:
                      "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.path != "/profile"
          ? _c(
              "div",
              { staticClass: "contact-content" },
              [
                _c("img", {
                  staticClass: "bottom-img",
                  attrs: { src: _vm.facebookImgSrc },
                  on: { click: _vm.gotoFacebook }
                }),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    attrs: { placement: "top", width: "150", trigger: "click" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "contact-img",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c("div", [_vm._v("Scott Cao-ShopVidi")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: require("../../assets/erweima2x.png") }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("whatsapp")]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                _vm.gotoWhatsApp()
                                return false
                              }
                            }
                          },
                          [_vm._v("\n            +852 60904204\n          ")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _c("img", {
                          staticClass: "bottom-img",
                          attrs: { src: _vm.phoneImgSrc }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("a", [
                  _c("img", {
                    staticClass: "bottom-img",
                    attrs: { src: _vm.emailImgSrc },
                    on: {
                      click: function($event) {
                        return _vm.gotoEmail()
                      }
                    }
                  })
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.path != "/profile"
          ? _c(
              "div",
              { staticClass: "content6-about" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "content6-about-txt",
                    attrs: { to: { name: "about" } }
                  },
                  [_vm._v("Our Story")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "content6-about-txt" }, [
                  _vm._v("|")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "content6-about-txt",
                    attrs: { to: { name: "service" } }
                  },
                  [_vm._v("Terms of Service")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "content6-about-txt" }, [
                  _vm._v("|")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "content6-about-txt",
                    attrs: { to: { name: "privacy" } }
                  },
                  [_vm._v("Privacy Policy")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "content6-about-txt" }, [
                  _vm._v("|")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "content6-about-txt",
                    attrs: { to: { name: "contact" } }
                  },
                  [_vm._v("Contact Us")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "content6-about-txt" }, [
                  _vm._v("|")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "content6-about-txt",
                    attrs: { to: { name: "return" } }
                  },
                  [_vm._v("Returns Policy")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0)
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "float" },
      [
        _vm.login
          ? _c(
              "el-badge",
              { staticClass: "item", attrs: { value: _vm.values } },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        return _vm.gotoImportList()
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: require("../../assets/img/float1.png") }
                    })
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.login
          ? _c("el-badge", { staticClass: "item" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.gotoMyOrder()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("../../assets/img/float2.png") }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                return _vm.gotoStore()
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../../assets/img/float3.png") }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content6-copy" }, [
      _c("span", { staticStyle: { color: "#5d5d5d" } }, [
        _vm._v("3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA")
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(" Copyright © 2025 ShopVidi Inc.")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25ba9ee0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ba9ee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/footer.vue
// module id = null
// module chunks = 